module.exports = __webpack_public_path__ + "static/media/exam.a1a585c1.png";